module.exports = __webpack_public_path__ + "img/05周奎元.031dd2be.png";